import React from "react";

export const NoDataAvailable: React.FC = () => (
  <div>No retest data available.</div>
);
